export enum SampleModals {
  LineageModal,
}
